import axiosInstance, { ensureCsrfToken } from '../utils/axiosInstance';

const authService = {
  login: async (email, password) => {
    try {
      // Ensure CSRF token is set
      await ensureCsrfToken();
      
      // Then attempt login
      const response = await axiosInstance.post('/api/login', {
        email,
        password,
      });
      
      return {
        user: response.data.user,
        message: response.data.message
      };
    } catch (error) {
      throw error.response?.data || { message: 'An error occurred during login' };
    }
  },

  logout: async () => {
    try {
      const response = await axiosInstance.post('/api/logout');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'An error occurred during logout' };
    }
  },

  getUser: async () => {
    try {
      const response = await axiosInstance.get('/api/user');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to get user data' };
    }
  },

  // Check if user is authenticated
  check: async () => {
    try {
      await axiosInstance.get('/api/user');
      return true;
    } catch (error) {
      return false;
    }
  },

  // Update user profile
  updateProfile: async (profileData) => {
    try {
      const response = await axiosInstance.put('/api/user/profile', profileData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to update profile' };
    }
  },

  // Change user password
  changePassword: async (passwordData) => {
    try {
      const response = await axiosInstance.put('/api/user/password', passwordData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to change password' };
    }
  },

  // Delete user account
  deleteAccount: async () => {
    try {
      const response = await axiosInstance.delete('/api/user/account');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to delete account' };
    }
  }
};

export default authService;
